<h3 class="font-extrabold mb-6">Order Recall: {{ data.name }}</h3>

<form [formGroup]="recallForm" class="overflow-x-hidden">
	<div class="grid">
		<app-dropdown
			*ngIf="data.unionOptions"
			[placeholder]="'Select Union'"
			[formControl]="recallForm.get('unionId')"
			[label]="'Union'"
			[fullWidth]="true"
			[options]="data.unionOptions">
		</app-dropdown>

		<label class="base-input-label w-full mt-2">
      Comments*
      <textarea
        formControlName="comments"
        cols="60"
        rows="3"
        placeholder="Type Comments"
        class="border-2 rounded mt-1 text-gray-600 p-4">
      </textarea>
		</label>
	</div>
	<app-dialog-footer 
		[valid]="recallForm.valid"
		[isSaving]="loading"
		[submitActionName]="'Confirm'"
		(cancelAction)="close()"
		(submitAction)="confirm()">
	</app-dialog-footer>
</form>